import React from 'react';
import { useParams } from 'react-router-dom'
import {EditClientProjects} from './EditClientProjects'
import { ButtonWIcon } from './Inputs'
import { useNavigate } from "react-router-dom";
import '../css/add_new_client_page.css'

const AddNewClientPage_p3 = () => {
    // Your code here

    const { id } = useParams()
    const navigate = useNavigate();

    function handleNextStepClick() {
        navigate('/client/' + id)
    }

    return (
        <div className='add-new-client-page'>
            <div className='header'>
                <h1>Vytvoření nového klienta</h1>
                <p>(krok 3/3)</p>
            </div>
            <EditClientProjects id={id} />
            <div className='control-bar'>
                <ButtonWIcon iconSrc={"/img/svg/next.svg"} text={"Další krok"}
                    style={{ backgroundColor: "#795BF3", color: "white" }}
                    onClick={handleNextStepClick} />
            </div>
        </div>
    );
};

export default AddNewClientPage_p3;